import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home/home'
import Recruit from '@/pages/recruit/recruit'
import ContactUs from '@/pages/contactus/contactus'
import JoinUs from '@/pages/joinus/joinus'
import JoinUsRecruit from '@/pages/joinus/recruid-info'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Home
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/recruit',
      name: 'Recruit',
      component: Recruit
    },
    {
      path: '/aso',
      redirect: '/home'
    },
    {
      path: '/yuetoutiao',
      redirect: '/home'
    },
    {
      path: '/taobaoke',
      redirect: '/home'
    },
    {
      path: '/contactus',
      name: 'ContactUs',
      component: ContactUs
    },
    {
      path: '/joinus',
      name: 'JoinUs',
      component: JoinUs
    },
    {
      path: '/joinusrecruit',
      name: 'JoinUsRecruit',
      component: JoinUsRecruit
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js